/* eslint-disable no-unused-vars */
import Hightlighter from 'react-highlight-words';
import * as S from './SwitchUserItem.styled';

const SwitchUserItem = ({
  //pb_id,
  pb_email,
  pb_company,
  pb_number,
  //selected,
  searchValue,
  onContextMenu,
  onClick,
  getLink,
}) => {
  return (
    <S.LinkContainer
      //to={getLink(pb_number)}
      onClick={onClick}
      onContextMenu={onContextMenu}
      //onMouseDown={onClick}
    >
      <S.Initials userType='Advertiser'>{pb_company?.charAt(0)?.toUpperCase()}</S.Initials>
      <S.Box1>
        <S.Name>
          <Hightlighter
            textToHighlight={pb_company}
            searchWords={[searchValue]}
            highlightTag='strong'
          />
        </S.Name>
        <S.Email>
          <Hightlighter
            textToHighlight={pb_email}
            searchWords={[searchValue]}
            highlightTag='strong'
          />
        </S.Email>
      </S.Box1>
      <S.Box2>
        <S.Number>
          <Hightlighter
            textToHighlight={pb_number + ''}
            searchWords={[searchValue]}
            highlightTag='strong'
          />
        </S.Number>
        {/* <S.Type userType='Advertiser'>Mock Data</S.Type> */}
      </S.Box2>
    </S.LinkContainer>
  );
};

export default SwitchUserItem;
